import logo from '@/assets/logo-o.svg'
import hamb from '@/assets/menu.svg'
import close from '@/assets/x.svg'
import tg from '@/assets/telegram.svg'
import wa from '@/assets/whatsapp.svg'
export default {
    logo,
    hamb,
    close,
    tg,
    wa,
    tree: [
        {
            title: 'Спикеры',
            href: '#spik'
        },
        {
            title: 'Программа',
            href: '#prog'
        },
        {
            title: 'Билеты',
            href: '#tariff'
        },
        {
            title: 'Контакты',
            href: '#cont'
        },
        {
            title: 'Спонсорам',
            href: '#sponsors'
        },
    ]
}